module.exports = __webpack_public_path__ + "static/media/comparison_icon_grey.f0e6c6e8.svg";